module.exports = __webpack_public_path__ + "img/312-2b5d02.png";